import { Controller } from '@hotwired/stimulus';
import { createFocusTrap } from 'focus-trap';

export default class extends Controller {
    connect () {
        this.focusTrap = createFocusTrap(this.element.firstElementChild, {
            initialFocus: this.element,
            clickOutsideDeactivates: true,
            onActivate: () => {
                document.body.classList.add('overlay');
                this.element.classList.add('visible');
            },
            onDeactivate: () => {
                document.body.classList.remove('overlay');
                this.element.classList.remove('visible');

                if (window.location.hash === `#${this.element.id}`) {
                    window.location.hash = '';
                }
            }
        });

        window.addEventListener('hashchange', () => {
            if (!this._checkHash()) {
                this.deactivate();
            }
        });

        setTimeout(() => this._checkHash(), 300);
    }

    disconnect () {

    }

    activate () {
        this.focusTrap.activate();
        this.dispatch('activate');
    }

    deactivate () {
        this.focusTrap.deactivate();
        this.dispatch('deactivate');
    }

    _checkHash () {
        if (window.location.hash === `#${this.element.id}`) {
            this.activate();
            return true;
        }

        return false;
    }
}
